import destroys from '../util/elements/destroys'
import on from '../util/elements/on'
import Pen from '../util/elements/pen'
import {
  line,
  lineLimit,
  distanceFromPoints,
  coordFromEvent,
} from '../util/math/graphing'

export default function canvasWidget(Site, $) {
  Site.widget('canvas', {
    _create() {
      destroys(this)

      const $window = $(window)
      this.pen = new Pen(this.element)

      this.pen.resize()
      this.pen.render()

      const start = on(this.element, 'mousedown touchstart', (e) => {
        e.preventDefault()
        this.startPos = coordFromEvent(e)
      })
      const move = on($window, 'mousemove touchmove', (e) => {
        if (this.startPos) {
          this.cur = coordFromEvent(e)

          this.pen.queue((pen, cancel) => {
            this.pen.clear()
            const startPos = pen.coordOnCanvas(this.startPos)
            const currentPos = pen.coordOnCanvas(this.cur)

            const multiply = pen.withPaint({ blend: 'multiply' })

            let curLine = line(startPos, currentPos)
            curLine = curLine.snap(45)

            if (distanceFromPoints(startPos, currentPos) < pen.pixels(40)) {
              this.theLine = curLine
            }

            pen.circle({
              ...startPos,
              fill: 'blue',
              r: 5,
            })

            pen.circle({
              ...currentPos,
              fill: this.theLine
                ? this.theLine.distanceFromPoint(currentPos) < pen.pixels(30)
                  ? 'orange'
                  : 'red'
                : 'red',
              r: 5,
            })

            const limits = lineLimit(
              this.theLine ? this.theLine : curLine,
              { x: 0, y: 0 },
              { x: this.pen.ctxWidth, y: this.pen.ctxHeight }
            )

            pen.line({
              from: limits.start,
              to: limits.end,
              stroke: 'red',
            })

            multiply()

            pen.circle({
              x: 300,
              y: 300,
              fill: 'green',
              r: 20,
            })
          })

          this.pen.render()
        }
      })
      const end = on($window, 'mouseup touchend', (e) => {
        this.startPos = false
      })
      const resize = on($window, 'resize', (e) => this.pen.resize())

      // Call all destroy functions
      this.destroys(start, move, end, resize, this.pen.destroy)
    },
    _transitionIn() {
      this.pen.resize()

      setTimeout(() => {
        this.pen.resize()
      }, 1000)
    },
  })
}
